// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__OKs9M","log":"ModalInventoryLogs_log__3Tqqt","date":"ModalInventoryLogs_date__31RQw","userName":"ModalInventoryLogs_userName__3MsKk"};